import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import cloneDeep from 'lodash/cloneDeep';
import last from 'lodash/last';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { getFormValues } from 'redux-form';
import qs from 'qs';

import { createSelectOptionsFromSysEnums } from '../../shared/form-elements/select';
import http from '../../shared/http';
import endpoints from '../../../config/endpoints';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import createGeneralForm from '../components/forms/general';

const mainForm = createGeneralForm({
	namespace: 'chainEdit',
	stateNodeName: 'mainForm'
});

// actions types

const FETCH_COUNTRY_SUCCESS = 'chainingEditor/fetch-country-success';
const FETCH_COUNTRY_ERROR = 'chainingEditor/fetch-country-error';

const FETCH_AFFILIATE_EMAIL_SUCCESS = 'chainingEditor/fetch-affiliate-email-success';
const FETCH_AFFILIATE_EMAIL_ERROR = 'chainingEditor/fetch-affiliate-email-error';

const FETCH_EMPTY_DATA = 'chainingEditor/fetch-empty-data';

const FETCH_OFFERS_SUCCESS = 'chainingEditor/fetch-country-success';
const FETCH_OFFERS_ERROR = 'chainingEditor/fetch-country-error';

const FETCH_TRANSITS_SUCCESS = 'chainingEditor/fetch-country-success';
const FETCH_TRANSITS_ERROR = 'chainingEditor/fetch-country-error';

const FETCH_LANDINGS_FORM_SUCCESS = 'chainingEditor/fetch-country-success';
const FETCH_LANDINGS_FORM_ERROR = 'chainingEditor/fetch-country-error';

const FETCH_AFFILIATES_FORM_SUCCESS = 'chainingEditor/fetch-country-success';
const FETCH_AFFILIATES_FORM_ERROR = 'chainingEditor/fetch-country-error';

const TOGGLE_PROGRESS_BAR = 'chainingEditor/toggle-progress-bar';
const TAB_CHANGE = 'chainingEditor/tab-change';

const FETCH_CHAIN_SUCCESS = 'chainingEditor/fetch-offer-success';

const FETCH_ERROR = 'chainingEditor/fetch-error';

// permissions
export const allowedPermissions = {
	'view': 'chains_view',
	'edit': 'chains_update',
	'create': 'chain_create'
};

// initial state
const initialState = {
	// data its empty array for renderViewState functionality
	// switch view to hasData state
	data: null,
	chain: null,
	landing: null,
	transit: null,
	targeting: null,
	individualTerms: null,
	locationRestrictions: null,
	showProgressBar: false,
	defaultLanguage: 'en',
	countriesOptions: null,
	offerOptions: null,
	transitOptions: null,
	currentTab: 'main',
	mainForm: mainForm.initialState,
	shouldResetForm: false,
	affiliateEmails: null,
	error: false
};

const filterOfferDomains = (type, offerLang) => elem =>
	elem.type === type && isEmpty(elem.affiliate_ids) && elem.languages.includes(offerLang);
// actions
export const actions = Object.assign({

	tabChange: tabIndex => (dispatch, getState) => {
		const { chain } = getState().chainEdit;
		if (tabIndex === 'main') {
			const { pathname } = window.location;
			const lastParams = parseInt(last(pathname.split('/')));
			if (Number.isInteger(lastParams) && isEmpty(chain)) {
				dispatch(actions.toggleProgressBar());
				dispatch(actions.fetchData(lastParams)).then(action => {
				});
			}
		}
		dispatch({
			type: TAB_CHANGE,
			payload: tabIndex
		});
	},

	fetchData: props => dispatch => {
		const { pathname } = window.location;
		const id = last(pathname.split('/')) ? last(pathname.split('/')) : '';

		const request = http({
			url: `${endpoints.CHAINS.BASE}/${id}?extend=comment,affiliates,offer,country,landing,transit`,
			method: 'get',
			actions: [
				FETCH_CHAIN_SUCCESS,
				FETCH_ERROR
			]
		});
		return request(dispatch);
	},

	loadTransitsPages: (text) => (dispatch, getState) => {
		const offerId = get(getFormValues('chainMainForm')(getState()), ['offer_id', '0', 'value']);
		const offer_lang = get(getFormValues('chainMainForm')(getState()), ['language', '0', 'value']);
		const request = http({
			url: endpoints.OFFERS.LANDINGS.replace('{id}', offerId),
			method: 'get',
			actions: [
				FETCH_TRANSITS_SUCCESS,
				FETCH_TRANSITS_ERROR
			]
		});

		return request(dispatch)
			.then(action => {
				if (action.type === FETCH_TRANSITS_SUCCESS) {
					const transits = action.payload.data.filter(filterOfferDomains('transit', offer_lang));
					return {
						options: createSelectOptionsFromSysEnums(transits)
					};
				}
			});
	},

	loadLandingsPages: () => (dispatch, getState) => {
		const offerId = get(getFormValues('chainMainForm')(getState()), ['offer_id', '0', 'value']);
		const offer_lang = get(getFormValues('chainMainForm')(getState()), ['language', '0', 'value']);
		const request = http({
			url: endpoints.OFFERS.LANDINGS.replace('{id}', offerId),
			method: 'get',
			actions: [
				FETCH_LANDINGS_FORM_SUCCESS,
				FETCH_LANDINGS_FORM_ERROR
			]
		});

		return request(dispatch)
			.then(action => {
				if (action.type === FETCH_LANDINGS_FORM_SUCCESS) {
					const landings = action.payload.data.filter(filterOfferDomains('landing', offer_lang));
					return {
						options: createSelectOptionsFromSysEnums(landings)
					};
				}
			});
	},

	loadOffersOptions: options => (dispatch, getState) => text => {
		const country = get(getFormValues('chainMainForm')(getState()), ['country_id', '0', 'value']);
		const country_query = qs.stringify({ filters: { locations_ids: [country] } });
		const request = http({
			url: `${endpoints.OFFERS.BASE}?${country_query}&search=${text}`,
			method: 'get',
			actions: [
				FETCH_OFFERS_SUCCESS,
				FETCH_OFFERS_ERROR
			]
		});

		return request(dispatch).then(action => {
			if (action.type === FETCH_OFFERS_SUCCESS) {
				return {
					options: createSelectOptionsFromSysEnums(action.payload.data)
				};
			}
		});
	},

	loadCountriesOptions: text => dispatch => {
		const request = http({
			url: `${endpoints.LOOKUPS.LOCATIONS}?query=${text}`,
			method: 'get',
			actions: [
				FETCH_COUNTRY_SUCCESS,
				FETCH_COUNTRY_ERROR
			]
		});

		return request(dispatch).then(action => {
			if (action.type === FETCH_COUNTRY_SUCCESS) {
				return {
					options: createSelectOptionsFromSysEnumsForCountries(action.payload.data)
				};
			}
		});
	},

	loadAffiliatesOptions: text => dispatch => {
		const request = http({
			url: `${endpoints.LOOKUPS.AFFILIATES}?query=${text}`,
			method: 'get',
			actions: [
				FETCH_AFFILIATES_FORM_SUCCESS,
				FETCH_AFFILIATES_FORM_ERROR
			]
		});

		return request(dispatch).then(action => {
			if (action.type === FETCH_COUNTRY_SUCCESS) {
				return {
					options: createSelectOptionsFromSysEnums(action.payload.data)
				};
			}
		});
	},

	toggleProgressBar: () => ({
		type: TOGGLE_PROGRESS_BAR
	}),
	fetchEmptyData: () => ({
		type: FETCH_EMPTY_DATA,
		payload: []
	})
},
mainForm.actions,
);

// reducers
const reducers = Object.assign({
	[LOCATION_CHANGE]: (state, action) => {
		if (action.payload.pathname.indexOf('chaining/editor') === -1) {
			return initialState;
		}
		return state;
	},
	['@@redux-form/CHANGE']: (state, action) => {
		return state;
	},
	[FETCH_CHAIN_SUCCESS]: (state, action) => {
		return {
			...state,
			data: action.payload.data,
			chain: action.payload.data,
			mainForm: {
				...state.mainForm,
				comment: {
					...state.mainForm.comment
				}
			},
			showProgressBar: false
		};
	},
	[FETCH_EMPTY_DATA]: (state, action) => ({
		...state,
		data: action.payload
	}),
	[FETCH_COUNTRY_SUCCESS]: (state, action) => ({
		...state,
		countriesOptions: action.payload.data
	}),
	[FETCH_OFFERS_SUCCESS]: (state, action) => ({
		...state,
		offerOptions: action.payload.data
	}),
	[FETCH_TRANSITS_SUCCESS]: (state, action) => ({
		...state,
		transitOptions: action.payload.data
	}),
	[FETCH_AFFILIATE_EMAIL_SUCCESS]: (state, action) => ({
		...state,
		affiliateEmails: action.payload.data
	}),
	[FETCH_AFFILIATE_EMAIL_ERROR]: state => ({ ...state, error: true, showProgressBar: false }),
	[FETCH_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
	[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
	[TAB_CHANGE]: (state, action) => ({ ...state, currentTab: action.payload })
},
mainForm.reducers,
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.chainEdit.data,
	getTargeting: state => state.programsEditor.targeting,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getProgressBar: state => state.chainEdit.showProgressBar,
	getCurrentTab: state => state.programsEditor.currentTab,

	getMainTabLangs: state => {
		const { currentLanguage } = state.chainEdit.mainForm;
		return getTabLangs('main', currentLanguage)(state);
	},

	getMainFormData: mainForm.selectors.getMainFormData,

	getLanguages: (state) => {
		return createSelectOptionsFromSysEnums(state.root.lists['landing-languages']);
	},

	loadStatusOptions: state => createSelectOptionsFromSysEnums(state.root.lists['chain-statuses']),
	loadAffiliateStatusOptions: state => createSelectOptionsFromSysEnums(state.root.lists['affiliate-internal-statuses']),
	loadMarkOptions: state => createSelectOptionsFromSysEnums(state.root.lists['chain-marks']),
	loadTrafficOptions: state => createSelectOptionsFromSysEnums(state.root.lists['traffic-types']),

	getChainName: state => {
		const { pathname } = window.location;
		const chain_id = parseInt(last(pathname.split('/'))) || '';
		const formData = getFormValues('chainMainForm')(state);
		const language = get(formData, ['language', '0', 'value']) || '';
		const offer_label = get(formData, ['offer_id', '0', 'label']) || '';

		const landing_id = get(formData, ['landing_id', '0', 'value']) || '';
		const transit_id = get(formData, ['transit_id', '0', 'value']) || '';
		const title = get(formData, ['unique_title']) || '';
		let name = '';
		if (!chain_id) {
			name = offer_label ? `${offer_label}_${transit_id}_${landing_id}_${language}_${title}` : '';
		}
		else {
			name = get(state, ['chainEdit', 'data', 'name']);
		}

		return name;
	},

	getError: state => state.chainEdit.error
};

// function
function getTabLangs(tabIndex, currentLanguage) {
	return state => {
		const { defaultLanguage } = state.chainEdit;

		let langs = state.root.lists.languages;

		return langs.map(lang => ({
			...lang,
			isSelected: true,
			isActive: lang.id === currentLanguage,
			isDefault: lang.id === defaultLanguage
		}));
	};
}

function createSelectOptionsFromSysEnumsForCountries(sysEnums) {
	return sysEnums && sysEnums.map(
		enumObject => ({
			value: enumObject.id,
			label: enumObject.text || enumObject.title,
			country_code: enumObject.country_code.toLowerCase()
		}));
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/chaining/editor/index.js